const b01 = `
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 16 16 16 16 00 00 00 00 00 00 00
`

const b02 = `
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 16 17 16 15 14 13 13 14 15 16 17 16 00 00 00
00 00 00 00 16 15 14 13 12 12 13 14 15 16 00 00 00 00
00 00 00 00 15 14 13 12 11 11 12 13 14 15 00 00 00 00
00 00 00 00 14 13 12 11 00 00 11 12 13 14 00 00 00 00
00 00 00 00 00 00 00 16 16 16 16 00 00 00 00 00 00 00
`

const b03 = `
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 16 14 16 14 16 00 00 00 00 00 00 00
00 00 00 00 00 15 13 14 15 15 14 13 15 00 00 00 00 00
00 00 00 00 00 00 00 16 16 16 16 00 00 00 00 00 00 00
`

const b04 = `
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
00 00 00 18 18 18 18 00 00 00 00 18 18 18 18 00 00 00
00 00 00 18 00 00 18 14 14 14 14 18 00 00 18 00 00 00
00 00 00 18 00 00 18 14 14 14 14 18 00 00 18 00 00 00
00 00 00 18 18 18 18 00 00 00 00 18 18 18 18 00 00 00
`

export function randomBlocksGenerator() {
  const b = [b01, b02, b03, b04]

  return b[Math.floor(Math.random() * b.length)]
}

export default randomBlocksGenerator()
//export default b04
